<div
  class="border white-bg ps-medium-b"
  [ngClass]="{
    'rounded-large': roundedBottom,
    'rounded-top-large': !roundedBottom
  }"
>
  <fin-expander-card
    data-test-flight-review-card-title
    class="block"
    [expandOpen]="cardExpanderOpen"
    [iconName]="'aircraft-horizontal-block'"
    [iconCategory]="'svg-library'"
    [title]="title"
    [subTitleIcon]="paxIcon"
    [subTitle]="passengers.length"
    [showSubTitleOnMobile]="true"
    [descriptionContent]="descriptionContent"
    (expandChange)="toggleOpenCard($event)"
  >
    <ng-container ngProjectAs="expandedContent">
      <div class="ps-medium-x ps-medium-b" [class.dim]="dim">
        <div class="font-body-1 dark-grey flex">
          <div class="ps-xxsmall">
            <h4 data-test-pax-flight-review-card-date>
              {{ flightOrBound?.departure?.dateTime | finDateFormat: 'DATE' }}
            </h4>
          </div>
        </div>
        <fcom-ufo-with-modify-button
          class="block ps-medium-t"
          [flightOrBound]="flightOrBound"
          [title]="title"
          [hideModify]="hideModify"
          [hideViewDetails]="hideViewDetails"
          [paxReviewCard]="true"
          [locations]="locations"
          (viewDetails)="viewDetails.emit()"
          (modifyClicked)="modifyClicked.emit()"
        ></fcom-ufo-with-modify-button>
      </div>
    </ng-container>
  </fin-expander-card>

  <ng-content></ng-content>
</div>

<ng-template #descriptionContent>
  <fin-flight-summary [class.dim]="dim" [flightOrBound]="flightOrBound"></fin-flight-summary>
</ng-template>
